import React from 'react';
import { BookOpenIcon, CheckCircle2Icon, GiftIcon, MailCheckIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
import { CurrencyNote } from '../CurrencyNote';
import { TrustRow } from '../TrustRow';
import { MOCKUP_URL, offerIncludes, offerItems } from '../../data/offer';
export function OfferStack() {
  const total = offerItems.reduce((sum, item) => sum + item.value, 0);
  return <section id="offer" className="bg-navy-900 px-4 py-16 sm:px-5 sm:py-20" aria-labelledby="offer-title" data-id="element-241" data-mp="tspodivcmq21">
      <div className="mx-auto max-w-3xl" data-id="element-242" data-mp="f41vjkcw0ufs">
        <div className="text-center text-white" data-id="element-243" data-mp="f30bwrht2zmg">
          <p className="font-display text-sm font-extrabold uppercase text-gold" data-id="element-244" data-mp="k1lakmhetb8s">Your special digital collection offer</p>
          <h2 id="offer-title" className="mt-2 font-display text-[30px] font-black uppercase leading-[1.02] sm:text-5xl" data-id="element-245" data-mp="17r5v39t7ogk6">
            Maxillary Growth <span className="italic text-electric-light" data-id="element-246" data-mp="1ckik3l1sypdg">Blueprint™</span>
          </h2>
          <p className="mt-3 text-base font-semibold text-white/85" data-id="element-247" data-mp="18us8or856wji">6 Specialized Clinical Volumes + 5 Exclusive Bonuses</p>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl bg-white shadow-[0_24px_60px_rgba(0,0,0,0.35)]" data-id="element-248" data-mp="1in7r1pncpn4x">
          <img src={MOCKUP_URL} alt="The complete Maxillary Growth Blueprint collection" className="mx-auto w-full max-w-md px-4 pt-6" data-id="element-249" data-mp="1dvpowy9ldgid" />

          <div className="px-5 pb-8 sm:px-10" data-id="element-250" data-mp="1rlt7nf99is32">
            <p className="text-center font-display text-sm font-extrabold uppercase text-navy-900" data-id="element-251" data-mp="1mojg9u2bc6cl">Here’s the complete offer:</p>
            <table className="mt-4 w-full text-left" data-id="element-252" data-mp="21kilmwy1fse1">
              <thead data-id="element-253" data-mp="1wmh4wio3455q">
                <tr className="border-b-2 border-navy-950 text-[11px] font-bold uppercase tracking-wide text-ink/55" data-id="element-254" data-mp="1wlxk8u71v2o0">
                  <th scope="col" className="pb-2" data-id="element-255" data-mp="78khvaihzopj">Included resource</th>
                  <th scope="col" className="pb-2 text-right" data-id="element-256" data-mp="28zemnwaou70">Ref. value</th>
                </tr>
              </thead>
              <tbody data-id="element-257" data-mp="rxn0jaut856f">
                {offerItems.map(item => {
                const Icon = item.isBonus ? GiftIcon : BookOpenIcon;
                return <tr key={item.label} className="border-b border-navy-900/10" data-id="element-258" data-mp="10xjhsreve1rg">
                      <td className="py-3 pr-3" data-id="element-259" data-mp="10zmgdzu3937s">
                        <span className="flex items-start gap-2 text-[14px] font-semibold leading-snug text-ink sm:text-[15px]" data-id="element-260" data-mp="15xe6qpf34h9v">
                          <Icon className={`mt-0.5 h-4 w-4 shrink-0 ${item.isBonus ? 'text-alert' : 'text-electric'}`} aria-hidden="true" data-id="element-261" data-mp="1av7fnq7rvpdu" />
                          {item.label}
                        </span>
                      </td>
                      <td className="py-3 text-right font-display text-base font-extrabold text-ink/70" data-id="element-262" data-mp="1omkwuxi7kb5p">${item.value}</td>
                    </tr>;
              })}
                <tr data-id="element-263" data-mp="1tk495rvcidv0">
                  <th scope="row" className="pt-4 font-display text-sm font-black uppercase text-navy-950" data-id="element-264" data-mp="1ykiireclhvv5">Total reference value</th>
                  <td className="pt-4 text-right font-display text-xl font-black text-alert line-through" data-id="element-265" data-mp="3j3ubf6zgk0cg">${total}</td>
                </tr>
              </tbody>
            </table>
            <p className="mt-2 text-[11px] leading-snug text-ink/50" data-id="element-266" data-mp="3943ivaugjvf0">
              Reference values are illustrative offer-comparison values, not verified standalone selling prices.
            </p>

            <div className="mt-8 rounded-2xl bg-mist px-4 py-6 text-center" data-id="element-267" data-mp="5ofyophccumd">
              <p className="font-display text-sm font-extrabold uppercase text-ink/60" data-id="element-268" data-mp="pd45yyzm6sn">Your price today:</p>
              <p className="mt-1 font-display text-2xl font-black text-ink/40 line-through" data-id="element-269" data-mp="3s391447sw6vw">${total}</p>
              <p className="font-display text-[15px] font-black uppercase text-alert" data-id="element-270" data-mp="3n57gvfyn21iu">Only</p>
              <p className="font-display text-7xl font-black leading-none text-navy-950 sm:text-8xl" data-id="element-271" data-mp="of7eo9vu3j9q">
                $27<span className="ml-1 align-top text-xl" data-id="element-272" data-mp="jnpcxjlzlenp">USD</span>
              </p>
              <p className="mt-3 font-display text-sm font-extrabold uppercase text-navy-800" data-id="element-273" data-mp="467hwzm0hv2o">
                One payment. The complete digital collection.
              </p>
            </div>

            <p className="mt-7 font-display text-sm font-extrabold uppercase text-navy-900" data-id="element-274" data-mp="3qd5w4b05horf">You receive:</p>
            <ul className="mt-3 grid gap-2.5 sm:grid-cols-2" data-id="element-275" data-mp="3vbzas6r6blt6">
              {offerIncludes.map(item => <li key={item} className="flex gap-2.5 text-[15px] leading-snug text-ink" data-id="element-276" data-mp="mvw2pzw5fv4b">
                  <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-success" aria-hidden="true" data-id="element-277" data-mp="rw1wbllzbrp1" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-8 flex flex-col items-center gap-6" data-id="element-278" data-mp="i5pcjvlzo2jy">
              <ScarcityBar data-id="element-279" data-mp="i3w7uluxrsel" />
              <CtaButton label="Yes! Give me the complete blueprint" data-id="element-280" data-mp="15v9z0ohcphxz" />
              <Countdown data-id="element-281" data-mp="15tyqycgvho12" />
              <CurrencyNote data-id="element-282" data-mp="1am02txa4pcqk" />
              <TrustRow data-id="element-283" data-mp="1am9x3x27i622" />
              <p className="flex items-center gap-2 text-center text-[13px] text-ink/60" data-id="element-284" data-mp="1ankvfhcvulls">
                <MailCheckIcon className="h-4 w-4 shrink-0 text-electric" aria-hidden="true" data-id="element-285" data-mp="2vb43u21vin1n" />
                Digital delivery — access instructions are displayed at checkout.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}